import React, { useEffect, useState } from "react";
import QuestionCard from "../../UserDashboard/UserDashboardFaq/QuestionCard";

const DoctorFaq = () => {
  const [search, setSearch] = useState("");
  const [doctorFaq, setDoctorFaq] = useState([]);

  //   load data
  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/doctorFaq/getdoctorFaq`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data.length) {
          setDoctorFaq(data?.data);
        }
      });
  }, []);

  const filter = doctorFaq?.filter((faq) =>
    faq?.question?.toLowerCase()?.includes(search?.toLowerCase())
  );
  return (
    <div className=" my-10">
      <div className="bg-white p-5 rounded-md">
        <label className="font-medium">Have any Question?</label>
        <input
          type="search"
          onChange={(e) => setSearch(e.target.value)}
          className="w-full block focus:outline-none border border-secondary text-sm py-1.5 px-3 mt-2 rounded-md"
          placeholder="Search Question"
        />
      </div>

      <div>
        {filter?.map((faq) => (
          <QuestionCard key={faq?._id} faq={faq} />
        ))}
      </div>
    </div>
  );
};

export default DoctorFaq;
